import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { formatDate } from "../../utils/formatDate";

const PurchaseOrderDetailsModal = ({ purchase, open, onClose }) => {
  const clientId = localStorage.getItem("client_id");
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle>{"Master Purchase Details"}</DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            {!clientId ? (
              <Grid item xs={12} sm={12} md={12}>
                <CustomTypography
                  color="var(--text-heading)"
                  fontSize="14px"
                  fontWeight={400}
                >
                  Client
                </CustomTypography>
                <TextField
                  type="text"
                  size="small"
                  margin="dense"
                  placeholder="Client Name"
                  value={purchase?.client?.business_name || ""}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "var(--text-secondary)",
                    },
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "var(--bg-input)",
                    },
                  }}
                />
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Master P.O. Number
              </CustomTypography>
              <TextField
                placeholder="Master P.O. Number"
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={purchase?.no || ""}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Master P.O. Date
              </CustomTypography>
              <TextField
                placeholder="Master P.O. Date"
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={
                  purchase?.date
                    ? formatDate(purchase.date)
                    : ""
                }
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Master P.O. Expiration Date
              </CustomTypography>
              <TextField
                placeholder="Master P.O. Expiration Date"
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={
                  purchase?.expiration_date
                    ? formatDate(purchase.expiration_date)
                    : ""
                }
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Supplier
              </CustomTypography>
              <TextField
                placeholder="Po Date"
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={purchase?.supplier?.name}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "var(--text-secondary)",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default PurchaseOrderDetailsModal;
